import { object } from "yup";
import { teacherPedagogySchemaShape } from "@user-management-context/primary/teacher/teacher-pedagogy-subform/teacher-pedagogy.subform.schema";
import type { TeacherPedagogyFormInputs } from "@user-management-context/primary/teacher/teacher-pedagogy-subform/teacher-pedagogy.subform.schema";

export const pedagogyStepSchema = object(teacherPedagogySchemaShape);

export type PedagogyStepInputs = TeacherPedagogyFormInputs;
